import { HttpClient } from '@angular/common/http';
import { ResponseObject } from '@app/shared/models/response-object';
import { StatusRequest, VerifyUserResquest } from '@app/shared/models/users-management';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

export class ActionUserManagementApi {
  apiUrl = environment.API_URL;

  constructor(public http: HttpClient) {}

  unblockUser(RequestBody: { list_user_id_reason: StatusRequest[] }): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(this.apiUrl + '/user/admin/users/unblock', RequestBody)
      .pipe(
        retry(1),
        map((res: any) => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  deactivateUser(RequestBody: { list_user_id: string[] }): Observable<ResponseObject> {
    return this.http.put<ResponseObject>(this.apiUrl + '/user/users/deactivate', RequestBody).pipe(
      retry(1),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  blockUser(RequestBody: { list_user_id_reason: StatusRequest[] }): Observable<ResponseObject> {
    return this.http.put<ResponseObject>(this.apiUrl + '/user/admin/users/block', RequestBody).pipe(
      retry(1),
      map((res: any) => {
        return res;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  deleteUser(RequestBody: { list_user_id_reason: StatusRequest[] }): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(this.apiUrl + '/user/admin/users/delete', RequestBody)
      .pipe(
        retry(1),
        map((res: any) => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  verifyUser(RequestBody: { verify_user_request: VerifyUserResquest }): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(
        this.apiUrl +
          `/user/admin/user/${RequestBody.verify_user_request.userId}/verify-blue-tick?isVerifiedUser=${RequestBody.verify_user_request.isVerifiedUser}`,
        {}
      )
      .pipe(
        retry(1),
        map((res: any) => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
